import React from "react";
import { connect } from "react-redux";
import { Mixpanel } from '../../redux/Mixpanel';
import store from "../../redux/store";
import _ from 'lodash';
import {Card} from "@tremor/react";
import {
    IonButton,
    IonContent, IonHeader, IonIcon, IonPage,
    IonSearchbar, IonTitle, IonToolbar,
    IonList, IonInfiniteScroll, IonInfiniteScrollContent,
    IonModal, IonButtons,
    IonFab, IonFabButton, IonFabList, IonMenuButton,
    IonSelect, IonSelectOption, IonLoading,
    IonBadge, IonItem, IonCheckbox, IonChip, IonLabel
} from '@ionic/react';
import {Row, Col} from 'reactstrap';
import {
    add,
    receipt,
    optionsOutline,
} from 'ionicons/icons';
import dayjs from 'dayjs';
import { check_if_number } from "../../components/validationChecks";
import { formatDate } from "../../utils";
import {
    fetchOptions,
    showLoading,
    showFeatureComingSoon,
    fetchInvoices,
    sendInvoice,
    uploadBulkTransactions,
    downloadInvoiceOrReceipt,
    downloadTransactions,
    showCustomMessage,
    fetchCurrency,
    deleteInvoices
 } from "../../redux/actions";
 import InvoiceListItem from "./InvoiceListItem";
 import InvoiceForm from "../Forms/InvoiceForm";
import { fetchPropertiesUnitsTenants } from "../../redux/middleware";
import { withRouter } from 'react-router-dom';
import { UNIFORM_RESOURCE_LOCATORS, colorTheme } from '../../utils/constants';
import IonCustomPropertySelect from '../../components/IonCustomPropertySelect';
import * as PermChecker from "../../utils/PermUtils";
import NotificationPermissionModal from '../../components/NotificationPermissionModal';
import { openNotificationPromptIfEligible, handleNotificationPromptAllow, handleNotificationPromptDeny } from '../../utils/notificationPrompt';
const mapStateToProps = state => {
    return {
        properties: state.properties,
        units: state.units,
        tenants: state.tenants,
        invoices: state.invoices,
        invoicesOrder: state.invoicesOrder,
        invoicesSummary: state.invoicesSummary,
        options: state.options,
        user: state.user,
        currency: state.currency
    };
}

const mapDispatchToProps = {
    fetchInvoices,
    fetchOptions,
    showLoading,
    showFeatureComingSoon,
    sendInvoice,
    uploadBulkTransactions,
    downloadInvoiceOrReceipt,
    downloadTransactions,
    deleteInvoices,
    showCustomMessage,
    fetchCurrency
};

const INVOICES_TAB = "invoices";

const PAGE_HOME = "homepage";
const PAGE_INVOICE_FORM = "invoiceForm";
const PAGE_FILTERS = "filters";

class Invoices extends React.Component{
    constructor(props) {
        super(props);

        this.handleCloseInvoiceForm = this.handleCloseInvoiceForm.bind(this);
        this.handleFilterModalDismiss = this.handleFilterModalDismiss.bind(this);

        const routerState = this.props.location.state || {};

        this.state = {
            tab: INVOICES_TAB,
            startDate: null,
            endDate: null,
            focusedDateInput: null,
            properties: [],
            invoices: [],
            selected: [],
            invoiceStatus: "",
            tenantDetails: null,
            filters: {
                status: [
                    { id: 1, value: "draft", isChecked: true },
                    { id: 2, value: "void", isChecked: true },
                    { id: 3, value: "open", isChecked: true },
                    { id: 4, value: "partial", isChecked: true },
                    { id: 5, value: "paid", isChecked: true },
                    { id: 6, value: "uncollectible", isChecked: true },
                    { id: 7, value: "credit-note", isChecked: true }
                ],
            },
            propertyId: "",
            unitId: "",
            tenantId: "",
            invoiceItem: "",
            minAmount: null,
            maxAmount: null,
            searchText: "",
            page: PAGE_HOME,
            currentPage: 0,
            invoiceId: "",
            errors: {
                minAmount: "",
                maxAmount: ""
            },
            invoicesOffset: "",
            selectedFile: null,
            userAllPerms: {},
            showLoading: false,
            isLoadingMore: false,
            showNotificationPrompt: false,
            filtersReady: false
        };
    }


    async fetchInitialData() {
        if (_.isEmpty(this.props.properties) || _.isEmpty(this.props.tenants)) {
            await store.dispatch(fetchPropertiesUnitsTenants);
        }
        await Promise.all([
            (
                async () => {
                    if (this.props.invoicesOrder.length == 0) {
                        this.props.showLoading(true);
                        let params = {
                            tenantIds: [], propertyIds: [], unitIds: [], startDate: null, endDate: null, status: this.getSelectedStatusFilters(),
                            invoiceItem: this.state.invoiceItem, offset: this.state.invoicesOffset || ""
                        }
                        let payloadResult = await this.props.fetchInvoices(params);
                        if (payloadResult && payloadResult.offset) {

                            let invoicesOffset = payloadResult.offset;
                            this.setState({
                                invoicesOffset
                            })
                        }
                    }
                }
            )(),
            (
                async () => {
                    if (_.isEmpty(this.props.options)) {
                        this.props.showLoading(true);
                        await this.props.fetchOptions();
                    }
                }
            )(),
            (
                async () => {
                    if(_.isEmpty(this.props.currency)){
                        this.props.showLoading(true);
                        await this.props.fetchCurrency();
                    }
                }
            )()
        ]);
    }

    getSelectedStatusFilters() {
        let allStatuses = this.state.filters.status;
        let selectedStatuses = [];
        allStatuses.map((status) => {
            if (status.isChecked) {
                selectedStatuses.push(status.value)
            }
        })
        return selectedStatuses
    }

    getUrlParams() {
        const searchParams = new URLSearchParams(this.props.location.search);
        return {
            propertyId: searchParams.get('propertyId') || '',
            unitId: searchParams.get('unitId') || '',
            tenantId: searchParams.get('tenantId') || '',
            startDate: searchParams.get('startDate') || '',
            endDate: searchParams.get('endDate') || '',
            invoiceItem: searchParams.get('invoiceItem') || '',
            status: searchParams.get('status') ? searchParams.get('status').split(',') : [],
            searchText: searchParams.get('searchText') || ''
        };
    }

    updateUrlParams(params) {
        const searchParams = new URLSearchParams(this.props.location.search);
        Object.entries(params).forEach(([key, value]) => {
            if (value === null || value === undefined || value === '' || (Array.isArray(value) && value.length === 0)) {
                searchParams.delete(key);
            } else {
                const formatted = Array.isArray(value) ? value.join(',') : String(value);
                searchParams.set(key, formatted);
            }
        });
        const queryString = searchParams.toString();
        this.props.history.replace({ search: queryString ? `?${queryString}` : '' });
    }

    applyUrlParams(defaultPropertyId) {
        const params = this.getUrlParams();
        const hasStatus = params.status.length > 0;
        const nextStatus = this.state.filters.status.map((s) => ({
            ...s,
            isChecked: hasStatus ? params.status.includes(s.value) : s.isChecked
        }));
        return {
            propertyId: params.propertyId || defaultPropertyId,
            unitId: params.unitId || '',
            tenantId: params.tenantId || '',
            invoiceItem: params.invoiceItem || '',
            startDate: params.startDate ? dayjs(params.startDate) : null,
            endDate: params.endDate ? dayjs(params.endDate) : null,
            searchText: params.searchText || '',
            filters: {
                ...this.state.filters,
                status: nextStatus
            }
        };
    }


    async componentDidMount() {
        this.setState({showLoading: true});

        await this.fetchInitialData();

        const invoices = this.getInvoicesOrder();
        const hasAllInvoicePerm = PermChecker.checkUserHasPermission(PermChecker.INVOICE_MODEL, PermChecker.ALL_PERM, this.props.options?.userPermissions);
        const hasAllMsgPerm = PermChecker.checkUserHasPermission(PermChecker.MESSAGE_MODEL, PermChecker.ALL_PERM, this.props.options?.userPermissions);


        const defaultPropertyId = Object.values(this.props.properties).length === 1 ? Object.values(this.props.properties)[0].propertyId : "";
        const urlState = this.applyUrlParams(defaultPropertyId);
        this.setState({
            properties: Object.values(this.props.properties),
            propertyId: urlState.propertyId,
            unitId: urlState.unitId,
            tenantId: urlState.tenantId,
            invoiceItem: urlState.invoiceItem,
            startDate: urlState.startDate,
            endDate: urlState.endDate,
            searchText: urlState.searchText,
            filters: urlState.filters,
            invoices,
            userAllPerms:{invoice: hasAllInvoicePerm, message: hasAllMsgPerm},
            filtersReady: true
        }, async () => {
            await this.filterInvoices();
        });
        this.setState({showLoading: false});
    }

    async componentDidUpdate(prevProps, prevState) {
        let props = this.props;

        if (this.props.invoices !== prevProps.invoices) {
            this.setState((state) => {
                const invoices = this.getInvoicesOrder();
                return {
                    invoices
                }
            });
        }
        if (!this.state.filtersReady) {
            return;
        }

        const filtersChanged = (
            this.state.filters !== prevState.filters ||
            this.state.invoiceItem !== prevState.invoiceItem ||
            this.state.startDate !== prevState.startDate ||
            this.state.endDate !== prevState.endDate ||
            this.state.propertyId !== prevState.propertyId ||
            this.state.unitId !== prevState.unitId ||
            this.state.tenantId !== prevState.tenantId
        );
        if (filtersChanged) {
            this.filterInvoices();
            this.updateUrlParams({
                propertyId: this.state.propertyId,
                unitId: this.state.unitId,
                tenantId: this.state.tenantId,
                startDate: this.state.startDate ? this.state.startDate.format('YYYY-MM-DD') : '',
                endDate: this.state.endDate ? this.state.endDate.format('YYYY-MM-DD') : '',
                invoiceItem: this.state.invoiceItem,
                status: this.getSelectedStatusFilters(),
                searchText: this.state.searchText
            });
        }
    }

    async filterInvoices(){
        let params  = this.getFilterParams();
        let invoicesOffset = "";
        this.props.showLoading(true);
        let payloadResult = await this.props.fetchInvoices(params);
        if (payloadResult) {
            invoicesOffset = payloadResult.offset;
        }

        this.setState((state) => {
            const invoices = this.getInvoicesOrder();
            return {
                invoices,
                invoicesOffset
            }
        });
    }

    getDefaultPropertyId(){
        const properties = Object.values(this.props.properties || {});
        return properties.length === 1 ? properties[0].propertyId : "";
    }

    handleClearFilters(){
        this.setState((prevState) => ({
            startDate: null,
            endDate: null,
            invoiceItem: "",
            propertyId: this.getDefaultPropertyId(),
            unitId: "",
            tenantId: "",
            filters: {
                ...prevState.filters,
                status: prevState.filters.status.map((s) => ({ ...s, isChecked: true }))
            }
        }));
    }

    renderActiveFilters(){
        const selectedStatuses = this.getSelectedStatusFilters();
        const allStatusesCount = this.state.filters.status.length;
        const hasStatusFilter = selectedStatuses.length !== allStatusesCount;
        const hasDateFilter = !!(this.state.startDate || this.state.endDate);
        const hasPropertyFilter = !!this.state.propertyId;
        const hasUnitFilter = !!this.state.unitId;
        const hasInvoiceItemFilter = !!this.state.invoiceItem;
        const hasFilters = hasStatusFilter || hasDateFilter || hasPropertyFilter || hasUnitFilter || hasInvoiceItemFilter;

        if (!hasFilters) return null;

        return (
            <div className="ion-padding-start ion-padding-end" style={{ marginBottom: '6px' }}>
                <div style={{ display: 'flex', gap: '8px', overflowX: 'auto' }}>
                    {hasPropertyFilter && (
                        <IonChip>
                            <IonLabel>Property</IonLabel>
                        </IonChip>
                    )}
                    {hasUnitFilter && (
                        <IonChip>
                            <IonLabel>Unit</IonLabel>
                        </IonChip>
                    )}
                    {hasDateFilter && (
                        <IonChip>
                            <IonLabel>Date Range</IonLabel>
                        </IonChip>
                    )}
                    {hasInvoiceItemFilter && (
                        <IonChip>
                            <IonLabel>Item</IonLabel>
                        </IonChip>
                    )}
                    {hasStatusFilter && (
                        <IonChip>
                            <IonLabel>Status</IonLabel>
                        </IonChip>
                    )}
                    <IonChip onClick={this.handleClearFilters.bind(this)}>
                        <IonLabel>Clear All</IonLabel>
                    </IonChip>
                </div>
            </div>
        );
    }

    handleCheckChildElement(value, checked){
        this.setState((prevState) => {
            let status = prevState.filters.status.map(s => {
                if (s.value === value){
                    return { ...s, isChecked: checked };
                }
                return { ...s };
            });
            return {
                filters: {
                    ...prevState.filters,
                    status
                }
            };
        });
    }

    async handleFilterModalDismiss(){
        this.setState({page: PAGE_HOME});
        await this.filterInvoices();
    }

    getFilterParams(offset="", appendData=false){
        let tenantIds = [];
        let unitIds = [];
        let propertyIds = [];

        if (this.state.propertyId) {
            propertyIds = [this.state.propertyId];
            if (this.state.unitId) {
                propertyIds = [];
                unitIds = [this.state.unitId];
                if (this.state.tenantId) {
                    unitIds = [];
                    tenantIds = [this.state.tenantId]
                }
            }
        }


        return ({
            tenantIds: tenantIds,
            propertyIds: propertyIds,
            unitIds: unitIds,
            startDate: this.state.startDate,
            endDate: this.state.endDate,
            status: this.getSelectedStatusFilters(),
            invoiceItem: this.state.invoiceItem,
            searchText: this.state.searchText,
            offset,
            appendData
        });
    }


    getInvoicesOrder() {
        let order = this.props.invoicesOrder;
        let orderedRecords = [];

        for (let id of order) {
            if ((this.props.invoices).hasOwnProperty(id)) {
                orderedRecords.push(this.props.invoices[id]);
            }
        }
        return this.formatInvoices(orderedRecords);
    }

    formatInvoices(invoices){
        return invoices.map(
            invoice => ({
                formattedDate: formatDate(invoice.invoiceDate),
                tenantName: invoice.tenant,
                propertyUnitName: `${this.props.properties[invoice.tenant.propertyId].propertyName} (${this.props.units[invoice.tenant.unitId].unitName})`,
                action: invoice,
                ...invoice
            })
        );
    }

    validateInput(name, value) {
        let val = String(value);
        let isValid = true;
        let errors = this.state.errors;
        let checks = [];
        switch (name) {
            case "minAmount":
                checks = [check_if_number];
                break;
            case "maxAmount":
                checks = [check_if_number];
                break;
            default:
                break;
        }
        for (let index in checks) {
            let previousError = errors[name];
            errors[name] = checks[index](val);
            if (errors[name].length > 0) {
                if (previousError.length == 0) {
                    this.setState((prevState) => ({ numErrors: prevState.numErrors + 1 }));
                }
                isValid = false;
                break;
            } else if (previousError.length > 0) {
                this.setState((prevState) => ({ numErrors: prevState.numErrors - 1 }));
            }
        }
        return isValid;
    }


    handleChange(event) {
        event.preventDefault();
        const target = event.target;
        let name = target.name;
        let val = target.type === 'checkbox' ? target.checked : target.value;
        this.setState({ [name]: val });
    }

    handleSelectEditInvoice(invoiceId, event) {
        event.preventDefault();
        this.setState({
            invoiceId: invoiceId,
            tenantDetails: this.props.invoices[invoiceId].tenant,
            page: PAGE_INVOICE_FORM
        });
    }

    handleChangeAmount(event) {
        event.preventDefault();
        const target = event.target;
        let name = target.name;
        let val = target.value == "" ? null : target.value;
        this.setState({ [name]: val });

        let isValid = this.validateInput(name, target.value);
    }

    handleSelectProperty(event) {
        event.preventDefault();
        let value = event.target.value;
        this.setState((prevState) => {
            let { propertyId, unitId, tenantId } = prevState;
            if (propertyId != value) {
                propertyId = value;
                unitId = "";
                tenantId = "";
            }
            return {
                propertyId, unitId, tenantId
            };
        });
    }

    handleSelectUnit(event) {
        event.preventDefault();
        let value = event.target.value;
        this.setState((prevState) => {
            let { unitId, tenantId } = prevState;
            if (unitId != value) {
                unitId = value;
                tenantId = "";
            }
            return {
                unitId,
                tenantId
            }
        });
    }

    handleSelectTenant(event) {
        event.preventDefault();
        let value = event.target.value;
        this.setState((prevState) => {
            return {
                tenantId: value
            };
        });
    }

    async handleSelectInvoiceAction(key, value) {
        if (key === 'edit') {
            this.setState({
                invoiceId: value,
                tenantDetails: this.props.invoices[value].tenant,
                page: PAGE_INVOICE_FORM
            });
            Mixpanel.track("Invoices tab: quick actions edit invoice");
        } else if (key === 'sendInvoice') {
            this.props.showLoading(true);
            this.props.sendInvoice({ invoiceIds: [value] });
            Mixpanel.track("Invoices tab: quick actions send message");
            await this.showNotificationPromptIfEligible();
        } else if(key === 'downloadInvoice'){
            this.props.showLoading(true);
            this.props.downloadInvoiceOrReceipt('invoice', value);
            await this.showNotificationPromptIfEligible();
        } else if (key == "delete"){
            if(confirm("Are you sure you want to delete this invoice?")){
                this.props.showLoading(true);
                const invoiceIds = [value];
                this.props.deleteInvoices(invoiceIds);
                Mixpanel.track("Invoice page: delete btn");
                await this.showNotificationPromptIfEligible();
            }
        }
    }

    onFileChange = event => {
        // Update the state
        this.setState({ selectedFile: event.target.files[0] });
    };

    onFileUpload = () => {
        // Create an object of formData
        const formData = new FormData();

        // Update the formData object
        formData.append(
        "transactions_csv",
        this.state.selectedFile,
        this.state.selectedFile.name
        )
        this.props.showLoading(true);
        this.props.uploadBulkTransactions(formData);
    };

    fetchMoreInvoices = async () => {
        if (this.state.isLoadingMore) return;
        this.setState({ isLoadingMore: true });
        if(!this.state.invoicesOffset) return;
        const params = this.getFilterParams(this.state.invoicesOffset, true);
        let payloadResult = await this.props.fetchInvoices(params);
        let invoicesOffset = this.state.invoicesOffset;
        if (payloadResult) {
            invoicesOffset = payloadResult.offset;
        }
        const invoices = this.getInvoicesOrder();
        this.setState({
            invoices,
            invoicesOffset,
            isLoadingMore: false
        });
    }

    handleCloseInvoiceForm(){
        this.setState({page: PAGE_HOME, invoiceId: "", tenantDetails: null });
        this.filterInvoices();
    }

    renderFilters(){
        return (
            <IonModal isOpen={this.state.page === PAGE_FILTERS} onDidDismiss={this.handleFilterModalDismiss}>
                <IonHeader>
                    <IonToolbar>
                        <IonTitle>Filters</IonTitle>
                        <IonButtons slot="end">
                            <IonButton onClick={this.handleFilterModalDismiss}>Close</IonButton>
                        </IonButtons>
                    </IonToolbar>
                </IonHeader>
                <IonContent className="ion-padding">
                    <div className='d-flex justify-content-center'>
                        <IonList style={{ width: '100%', maxWidth: '500px' }}>
                            <IonItem style={{ marginTop: '6px', marginBottom: '6px' }}>
                                <IonSelect
                                    label="Property"
                                    labelPlacement="stacked"
                                    interface="popover"
                                    value={this.state.propertyId}
                                    onIonChange={this.handleSelectProperty.bind(this)}
                                >
                                    <IonCustomPropertySelect propertiesArray={this.state.properties}/>
                                </IonSelect>
                            </IonItem>
                            <IonItem style={{ marginTop: '6px', marginBottom: '6px' }}>
                                <IonSelect
                                    label="Unit"
                                    labelPlacement="stacked"
                                    interface="popover"
                                    value={this.state.unitId}
                                    onIonChange={this.handleSelectUnit.bind(this)}
                                >
                                    <IonSelectOption key={""} value="">All Units</IonSelectOption>
                                    {this.state.propertyId == ""?
                                        <IonSelectOption>Please First Select a Property ...</IonSelectOption> :
                                        _.map(Object.keys(this.props.properties[this.state.propertyId]["units"]), (unit) => (
                                            <IonSelectOption key={unit} value={unit}>
                                                {this.props.units[unit].unitName}
                                            </IonSelectOption>
                                    ))}
                                </IonSelect>
                            </IonItem>
                            <IonItem lines="none" style={{ marginTop: '6px', marginBottom: '6px' }}>
                                <div style={{ width: '100%' }}>
                                    <div style={{ fontWeight: 700, fontSize: '1rem' }}>Date Range</div>
                                    <div style={{ display: 'flex', gap: '12px', marginTop: '8px' }}>
                                        <input
                                            type="date"
                                            id="invoicesStartDate"
                                            name="invoicesStartDate"
                                            value={this.state.startDate ? this.state.startDate.format('YYYY-MM-DD') : ''}
                                            onChange={(e) => {
                                                const value = e.target.value;
                                                this.setState({ startDate: value ? dayjs(value) : null });
                                            }}
                                            style={{ width: '100%', textAlign: 'center', padding: '8px', border: '1px solid gray' }}
                                        />
                                        <input
                                            type="date"
                                            id="invoicesEndDate"
                                            name="invoicesEndDate"
                                            value={this.state.endDate ? this.state.endDate.format('YYYY-MM-DD') : ''}
                                            min={this.state.startDate ? this.state.startDate.format('YYYY-MM-DD') : undefined}
                                            onChange={(e) => {
                                                const value = e.target.value;
                                                this.setState({ endDate: value ? dayjs(value) : null });
                                            }}
                                            style={{ width: '100%', textAlign: 'center', padding: '8px', border: '1px solid gray' }}
                                        />
                                    </div>
                                </div>
                            </IonItem>

                            <IonItem style={{ marginTop: '6px', marginBottom: '6px' }}>
                                <IonSelect
                                    label="Invoice Item"
                                    labelPlacement="stacked"
                                    interface="popover"
                                    value={this.state.invoiceItem}
                                    onIonChange={(e) => this.setState({ invoiceItem: e.detail.value })}
                                >
                                    <IonSelectOption key={""} value="">All</IonSelectOption>
                                    {_.map(this.props.options?.invoiceItems || [], (category) => (
                                        <IonSelectOption key={category} value={category}>
                                            {category}
                                        </IonSelectOption>
                                    ))}
                                </IonSelect>
                            </IonItem>

                            <IonItem lines="none" style={{ marginTop: '6px', marginBottom: '6px' }}>
                                <div style={{ width: '100%' }}>
                                    <div style={{ fontWeight: 700, fontSize: '1rem' }}>Invoice Status</div>
                                    {this.state.filters.status.map((status) => (
                                        <IonItem key={status.id + status.isChecked.toString()}>
                                            <IonCheckbox
                                                labelPlacement="end"
                                                checked={status.isChecked}
                                                onIonChange={(e) => this.handleCheckChildElement(status.value, e.detail.checked)}
                                            >
                                                {status.value}
                                            </IonCheckbox>
                                        </IonItem>
                                    ))}
                                </div>
                            </IonItem>
                        </IonList>
                    </div>
                </IonContent>
            </IonModal>
        )
    }

    renderInvoiceForm(){
        return (
            <IonModal isOpen={this.state.page === PAGE_INVOICE_FORM} onDidDismiss={this.handleCloseInvoiceForm}>
                <IonHeader>
                    <IonToolbar>
                        <IonTitle>Invoice Form</IonTitle>
                        <IonButtons slot="end">
                            <IonButton onClick={this.handleCloseInvoiceForm}>Close</IonButton>
                        </IonButtons>
                    </IonToolbar>
                </IonHeader>
                <IonContent className="ion-padding">
                    <InvoiceForm
                        tenantDetails={this.state.tenantDetails}
                        invoiceId={this.state.invoiceId}
                    />
                </IonContent>
            </IonModal>

        );
    }

    async showNotificationPromptIfEligible() {
        await openNotificationPromptIfEligible((open) => this.setState({ showNotificationPrompt: open }));
    }

    renderInvoicesTable(){
        return (
            <React.Fragment>
                <IonHeader className="ion-no-border">
                    <Row className='mx-0 mt-1'>
                        <Col className='mr-0 pr-0 mx-md-4' xs={10} md={10}>
                            <IonSearchbar
                                onIonInput={(e) => {
                                    this.setState({ searchText: e.detail.value });
                                }}
                                onIonChange={async (e) => {
                                    this.setState({ searchText: e.detail.value });
                                    await this.filterInvoices();

                                }}
                            />
                        </Col>
                        <Col className='mx-0 my-2 pt-1 rounded' xs={2} md={2} style={{width:'3.4375em', backgroundColor: colorTheme["primary"]["25"], color: colorTheme["primary"]["800"]}}>
                            <IonIcon onClick={ () => { this.setState({page: PAGE_FILTERS}) }}
                                size="large" aria-hidden="true" id='invoice-filter-icon'
                            icon={optionsOutline}
                            />
                        </Col>

                    </Row>
                    {this.renderActiveFilters()}

                </IonHeader>
                <div>
                <Card style={{margin: 0, padding: 0}}>
                    <IonList id="ion-list-descriptions" style={{margin: 0, padding: 0}}>
                    {this.state.invoices.map((invoice) => {
                        let tenantName = "";
                        let unitName = "";
                        let currency = "";
                        let propertyName = "";
                        if (invoice.tenant){
                            tenantName = invoice.tenant.firstName + " " + invoice.tenant.lastName
                            unitName = !_.isEmpty(this.props.units)? this.props.units[invoice.tenant.unitId].unitName: "";
                            currency = !_.isEmpty(this.props.currency)? this.props.currency.customerCurrency: "";
                            propertyName = !_.isEmpty(this.props.properties)? this.props.properties[invoice.tenant.propertyId].propertyName: "";
                        }
                        return (<InvoiceListItem
                            key={invoice.invoiceId}
                            invoiceId={invoice.invoiceId}
                            tenantName={tenantName}
                            amount={invoice.amount}
                            unitName={unitName}
                            propertyName={propertyName}
                            currency={currency}
                            invoiceDate={invoice.formattedDate}
                            invoice={invoice}
                            userAllPerms={this.state.userAllPerms}
                            showDetails={false}                            
                            handleInvoiceAction={this.handleSelectInvoiceAction.bind(this)}
                            options={this.props.options}
                        />
                        )
                    })}
                    </IonList>

                    <IonInfiniteScroll
                        threshold='100px'
                        onIonInfinite={async (ev) => {
                            if (this.state.isLoadingMore) {
                                ev.target.complete();
                                return;
                            }
                            this.setState({ isLoadingMore: true });
                            await this.fetchMoreInvoices();
                            this.setState({ isLoadingMore: false }, () => {
                                ev.target.complete();
                            });
                        }}
                    >
                        <IonInfiniteScrollContent loadingText="Please wait..." loadingSpinner="bubbles"></IonInfiniteScrollContent>
                    </IonInfiniteScroll>

                    {this.state.invoicesOffset && (
                        <div className="ion-padding">
                            <IonButton
                                expand="block"
                                onClick={async () => {
                                    this.props.showLoading(true);
                                    await this.fetchMoreInvoices();
                                    this.props.showLoading(false);
                                }}
                            >
                                Load More Invoices
                            </IonButton>
                        </div>
                    )}
                </Card>
                </div>

                <NotificationPermissionModal
                    isOpen={this.state.showNotificationPrompt}
                    header="Enable notifications?"
                    message="Enable reminders to create invoices on time and get paid on time."
                    onCancel={async () => {
                        await handleNotificationPromptDeny((open) => this.setState({ showNotificationPrompt: open }), 'invoices');
                    }}
                    onAllow={async () => {
                        await handleNotificationPromptAllow((open) => this.setState({ showNotificationPrompt: open }), 'invoices');
                    }}
                    onDeny={async () => {
                        await handleNotificationPromptDeny((open) => this.setState({ showNotificationPrompt: open }), 'invoices');
                    }}
                />

            </React.Fragment>
        )
    }

    renderHomePage(){
        return (
            <div>
                {this.renderInvoicesTable()}
            </div>
        )
    }

    render() {
        return (
          <IonPage>
            <IonHeader>
                <IonToolbar>
                    <IonButtons slot="start">
                        <IonMenuButton />
                    </IonButtons>
                    <IonTitle>Invoices</IonTitle>
                </IonToolbar>
            </IonHeader>
            <IonContent>
                <IonLoading className="custom-loading" isOpen={this.state.showLoading} message="Loading ..." />

                {this.state.page === PAGE_HOME && this.renderHomePage()}

                {/* render Modals */}
                {this.renderFilters()}
                {this.renderInvoiceForm()}
                <IonFab id="invoice-fab-button" className='ion-fab' slot="fixed" vertical="bottom" horizontal="end">
                    <IonFabButton aria-label="Actions">
                        <IonIcon icon={add} />
                    </IonFabButton>
                    <IonFabList side="top">
                        {this.state.userAllPerms.invoice &&
                        <>
                        <IonFabButton
                            onClick={() => this.props.history.push(UNIFORM_RESOURCE_LOCATORS.bulkCreateInvoices)}
                            id="bulk-create-invoices-fab-icon"
                            data-desc="Bulk Create Invoices"
                        >
                            <IonIcon icon={receipt}></IonIcon>
                        </IonFabButton>
                        <IonFabButton
                            onClick={async () => {
                                this.setState({page: PAGE_INVOICE_FORM});
                            }}
                            id="invoice-page-form-ion-fab-icon"
                            data-desc="Add New Invoice"
                        >
                            <IonIcon icon={receipt}></IonIcon>
                        </IonFabButton>
                        </>
                        }
                    </IonFabList>
                    </IonFab>
            </IonContent>
          </IonPage>
        );
      }
}


export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Invoices));